import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { Autocomplete, AutocompleteProps } from '@optimus-web/core';
import { getError } from '../../utils';

export const AutocompleteFieldRenderer = ({ meta, ...props }: WrappedFieldProps & AutocompleteProps) => (
    <Autocomplete error={getError(meta)} {...props} />
);

export type AutocompleteFieldProps = BaseFieldProps<AutocompleteProps>;

export const AutocompleteField = (props: AutocompleteFieldProps) => (
    <Field component={AutocompleteFieldRenderer} {...props} />
);
